import React from 'react';
import {observer, Observer, inject} from 'mobx-react';
import {toJS, action} from 'mobx';
import moment from 'moment';


import {SiteHeader} from '../component/SiteHeader';
import {SiteFooter} from '../component/SiteFooter';

import {BWStepBar} from '../component/BWStepBar';
import {BWReceipt} from '../component/BWReceipt';

import {fmtPrice, fmtPercent} from '../../model/formatters';
import translateBase from '../../translate';

function accessoriesWithOffers(aggAccessories) {
  return aggAccessories.joinedListing
  .filter(o => !o.isObligatory)
  .filter(o => o.hasBestOffers)
}

function accessoriesWithoutOffers(aggAccessories) {
  
  return aggAccessories.joinedListing
  .filter(o => !o.isObligatory)
  .filter(o => !o.hasBestOffers)
}

@observer
class AccessoryItem extends React.Component {
  componentDidMount() {
    window.sessionStorage.setItem('accessoriesPassed', 1);    
  } 
    
  render() {
    const {
      selected, 
      name, 
      currency, 
      flatPrice, 
      prolongationPrice,
      price,
      itemCount,
      onIncrease,
      onDecrease,
      canInc,
      canDec,
      sumTotalPrice,
    } = this.props;

    return (
      <div className={"list-entry" + (selected ? " selected" : "")}>
        <div className="input">{name}</div>
        <div className="value">{currency}  {fmtPrice((flatPrice || 0) + (prolongationPrice || 0) + (price || 0))}</div>
        <div className="amount">
            <input placeholder="0" value={itemCount} />
            <a className={"minus" + (canDec ? "" : " unselectable")} onClick={onDecrease}><i className="fa fa-minus"></i></a>
            <a className={"plus" + (canInc ? "" : " unselectable")} onClick={onIncrease}><i className="fa fa-plus"></i></a>
        </div>
        <div className="price">{currency} {fmtPrice(sumTotalPrice)}</div>
      </div>        
    )
  }
}

@inject(stores => ({ 
  navigation: stores.app.navigation,
  wAccessories: stores.app.wAccessories,
  accessoriesForm: stores.app.accessoriesForm,
  rentalTransaction: stores.app.rentalTransaction,
  bestOffers: stores.app.bestOffers,
  aggAccessories: stores.app.aggAccessories,
  vBookingWizard: stores.app.vBookingWizard,   
  //rentalObject: stores.app.rentalObject,
  businessUnit: stores.app.businessUnit,
  //scene: stores.app.scene,
}))
@observer
export class BWAccessories extends React.Component {

  getPrevActionLink() {
    const {navigation} = this.props;
    switch(this.props.vBookingWizard.prevAccessoriesAction) {
      case "Services":
        return <a className="back" onClick={navigation.goBWServices}><i className="fa fa-arrow-left" aria-hidden="true"></i> {this.translate("back", "Zurück")}</a>;
      case "OfferDetails":
        return <a className="back" onClick={navigation.goBWOfferDetails}><i className="fa fa-arrow-left" aria-hidden="true"></i> {this.translate("back", "Zurück")}</a>;
    }
  }

  render() {
    let translate = translateBase.bindPage('bw03Accessories');
    this.translate = translate;
    const {navigation, accessoriesForm, rentalTransaction, bestOffers, aggAccessories, businessUnit} = this.props;
    const currency = businessUnit.currencyName; //"CHF";
    const accWithOffers = accessoriesWithOffers(aggAccessories);
    const accWithoutOffers = accessoriesWithoutOffers(aggAccessories);
    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={3} />

        <BWReceipt />
 
        <section className="wizard-container booking-view">
            <div className="wrapper">
              <div className="row wizard-content"> 
                    <div className="column-12">
                        <h3 className="mali-blue">{translate("accessories", "Zubehör")}</h3>
                        {accWithOffers.length > 0 &&
                          <div className="services-entry with-best-offers">
                            {/*<div className="title">Available accessories</div>*/}
                            {accWithOffers.map(accessory => {
                              return (
                                <AccessoryItem
                                  selected={accessory.sumTotalPrice > 0}
                                  name={accessory.name}
                                  currency={currency}
                                  flatPrice={accessory.flatPrice}
                                  prolongationPrice={accessory.prolongationPrice}
                                  price={accessory.price}
                                  itemCount={accessoriesForm.values.get(accessory.pk)}
                                  onIncrease={() => accessoriesForm.incAmount(accessory.pk, accessory.maxQuantity)}
                                  onDecrease={() => accessoriesForm.decAmount(accessory.pk)}
                                  canInc={accessoriesForm.canInc(accessory.pk, accessory.maxQuantity)}
                                  canDec={accessoriesForm.canDec(accessory.pk)}
                                  sumTotalPrice={accessory.sumTotalPrice} />                                 
                              )
                            })}
                          </div>
                        }
                        {/*{accWithoutOffers.length > 0 && 
                          <div className="services-entry with-no-best-offers">
                            {/*<div className="title">Unavailable accessories</div>*/}{/*
                            {accWithoutOffers.map(accessory => {
                              return (
                                <AccessoryItem
                                  selected={accessory.sumTotalPrice > 0}
                                  name={accessory.name}
                                  currency={currency}
                                  flatPrice={accessory.flatPrice}
                                  prolongationPrice={accessory.prolongationPrice}
                                  price={accessory.price}
                                  itemCount={accessoriesForm.values.get(accessory.pk)}
                                  onIncrease={() => accessoriesForm.incAmount(accessory.pk)}
                                  onDecrease={() => accessoriesForm.decAmount(accessory.pk)}
                                  sumTotalPrice={accessory.sumTotalPrice} /> 
                              )
                            })}
                          </div>
                        }*/}
                    </div>
                </div>                

                <div className="row main-wizardbtns-container">
                    <div className="column-6">
                        {this.getPrevActionLink()}
                    </div>
                    <div className="column-6">
                        <a id="btn-fwd-bwacc" className="forward" onClick={navigation.goBWPersonalData}>{translate("next", "Weiter")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                    </div>
                </div>

            </div>
        </section>     

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/BWAccessories.js